import { useLoginSessionWatcher } from "src/domains/shared/hooks/useLoginSessionWatcher";

/**
 * 로그인 배타성의 열린 화면 감시자. 그리는 것은 없다. `_app` 에서 한 번 마운트한다.
 *
 * 열린 화면의 로그인 상태와 다른 탭의 사건을 감시할 뿐이다(`useLoginSessionWatcher`). `QueryClientProvider` 안에서
 * 돌아야 하는 감시 hook 의 자리다. 밀려남 처리기에 앱 의존을 주입하는 일은 `_app` 의 `useBindLoginSupersededHandler`
 * 가 맡는다.
 */
export const LoginSessionWatcher = (): null => {
  useLoginSessionWatcher();
  return null;
};
